import type { FaireProductEntity } from "../../entity_types/product";

export const p_m472tssyf8: FaireProductEntity = {
  token: "p_m472tssyf8",
  type: "product",
  name: "Gardener Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6804cf8b54b2b6454bb1e4fcd658523b4982b002ef3c52b542120c4e8357c14a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8b5f75128ac2a884785c76be8cba62326e3a3c6ac1a0912b84235b7536659c1.jpeg",
    "https://cdn.faire.com/fastly/a41e158e49da00938dde2176f1f8df51c62e08dda114efa59f20aea96afa0824.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:41.927Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
